import React from 'react';
// Constants
import { CompanyName, KeywordsPages, MainTitle } from '../../utils/Constants';
// Data
import {
  aboutPageAdditionalMeta,
  aboutPageStructuredData,
} from '../../utils/data/MetaData';
// Images
import MainImage from '../../assets/images/main/mistress-md-professional-dominatrix-blue-boots-on-throne.jpg';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import AboutPageMainContainer from '../../components/about/AboutPageMainContainer';
import GeneralHeader from '../../components/general/GeneralHeader';
import FooterComponent from '../../components/footer/FooterComponent';

function AboutPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='About Me'
        desc={`Get to know ${CompanyName}, a professional dominatrix, fetish specialist and wrestling empress based in Oldbury, West Midlands.`}
        keywords={KeywordsPages}
        additionalMeta={aboutPageAdditionalMeta}
        structuredData={aboutPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        {/* Main */}
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <GeneralHeader
            title='ABOUT ME'
            subtitle={MainTitle}
            imageUrl={MainImage}
            imageText={
              <>
                LEARN <br /> MORE
              </>
            }
            imageAlt={`${CompanyName} looking sinful`}
          >
            <p>
              Whether you crave the{' '}
              <strong className='text-colour5 dark:text-colour5'>
                sweet surrender
              </strong>{' '}
              of online submission or the
              <em> visceral thrill</em> of real-time sessions, I am here to
              guide you through a{' '}
              <strong className='text-colour5 dark:text-colour5'>
                labyrinth of lust and longing
              </strong>
              .
            </p>
            <p>
              Bow before your{' '}
              <strong className='text-colour5 dark:text-colour5'>
                NytNurse of Nastiness
              </strong>
              , the keeper of your <em>deepest, darkest secrets</em>, and
              prepare to{' '}
              <strong className='text-colour5 dark:text-colour5'>
                serve, worship, and submit
              </strong>{' '}
              to the whims of your undisputed Mistress.
            </p>

            <p>
              Are you
              ready to be tested, tormented, and transformed? Then step forward,{' '}
              <em>if you dare</em>.
            </p>
          </GeneralHeader>

          {/* Main page content */}
          <AboutPageMainContainer />

          {/* Footer */}
          <FooterComponent />
        </div>
      </div>
    </>
  );
}

export default AboutPage;
